import { useContext } from 'react';
import RagFlowIdContext from 'new/components/flows/types/genai_rag/context/RagFlowId/RagFlowIdContext';

export default function useRagFlowId() {
  return useContext(RagFlowIdContext);
}
